import { DateRange } from "@fullcalendar/core/internal";
import { Stack, Typography } from "@mui/material";
import React from "react";
import { TimeSelectorButton } from "@/components/booking/timeSelector/timeSelectorButton";

type Props = {
  disabled: boolean;
  onEdit: () => void;
  dateRange?: DateRange;
};

export const DateTimeSection = ({ disabled, onEdit, dateRange }: Props) => {
  return (
    <Stack gap={1.5}>
      <Typography variant="labelTiny" color="text.secondary">
        Select date & time
      </Typography>
      <TimeSelectorButton
        dateRange={dateRange}
        durationText=" based on selected service(s)"
        disabled={disabled}
        onClick={onEdit}
      />
    </Stack>
  );
};
